<template>
    <div>
        <b-card>
            <div>
                <b-table id="intake-outstanding-results" ref="intakeOutstandingResults" striped hover borderless
                         selectable
                         select-mode="single"
                         tbody-tr-class="text-center"
                         head-variant="dark"
                         primary-key="order_id"
                         no-provider-paging
                         no-provider-sorting
                         no-provider-filtering
                         show-empty
                         :busy.sync="isBusy"
                         :fields="fields"
                         :items="getResults"
                         :per-page="perPage"
                         :current-page="currentPage"
                         :sort-by.sync="sortBy"
                         :sort-desc.sync="sortDesc"
                         @row-selected="onRowSelected">
                    <template v-slot:cell(name)="data">
                        {{ data.item.first_name }} {{ data.item.last_name}}
                    </template>
                    <template v-slot:table-busy>
                        <LoadingSpinner :busy="isBusy"/>
                    </template>
                </b-table>

                <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        aria-controls="intake-outstanding-results"
                        align="center"
                        size="sm"
                ></b-pagination>
            </div>
        </b-card>
    </div>
</template>

<script>
    import LoadingSpinner from '../../components/LoadingSpinner';
    export default {
        name: 'intake-outstanding',
        components: {
            LoadingSpinner,
        },
        data() {
            return {
                perPage: 25,
                currentPage: 1,
                totalRows: 0,
                isBusy: false,
                sortBy: 'order_id',
                sortDesc: true,
                fields: [
                    {key: 'order.id', label: 'Order #', class: 'text-center', sortable: true},
                    {key: 'order.customer.id', label: 'Customer #', class: 'text-center', sortable: true},
                    {key: 'tracking_number', label: 'Tracking Number #', class: 'text-center', sortable: true},
                    {key: 'order.customer.full_name', label: 'Name', class: 'text-center', sortable: false},
                    {key: 'order.brand.name', label: 'Brand', class: 'text-center', sortable: true},
                    {key: 'order.outstanding_package_count', label: 'Packages Outstanding', class: 'text-center', sortable: true},
                ],
            };
        },
        computed: {

        },
        methods: {
            onRowSelected(items) {
                console.log(items);
                //TODO: navigate to order
                this.$router.push({ path: '/intake/view/' + items[0].tracking_number });
            },
            getResults(ctx, callback) {
                this.$http.get('/orders/bystatus/delivered')
                    .then(response => {
                        callback(response.data.data);
                    });

                return null;
            },
        },
        watch: {

        }
    };
</script>

<style scoped>

</style>
